import styles from './BasketCardForCheckout.module.scss'

interface BasketCardForCheckoutProps {
  data: any
  optionGroup: any
}

const BasketCardForCheckout = ({ data, optionGroup }: BasketCardForCheckoutProps) => {
  const hasImages = data?.images && data.images.length > 0
  const imageUrl = hasImages ? data.images[0]?.original : data.thumb

  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <span className={styles.quantityBadge}>{optionGroup.totalQuantity}</span>
        <img src={imageUrl} alt={data.name} className={styles.image} />
      </div>
      <div className={styles.content}>
        <div className={styles.namePrice}>
          <h3 className={styles.productName}>{data.name}</h3>
          <p className={styles.price}>{data.special ?? data.price}</p>
        </div>
        <p className={styles.variant}>{optionGroup.value}</p>
      </div>
    </div>
  )
}

export default BasketCardForCheckout
